export const TwentyOne = 'J';